import { render, staticRenderFns } from "./BUploadZone.vue?vue&type=template&id=30f23bf6&scoped=true&"
import script from "./BUploadZone.vue?vue&type=script&lang=js&"
export * from "./BUploadZone.vue?vue&type=script&lang=js&"
import style0 from "./BUploadZone.vue?vue&type=style&index=0&id=30f23bf6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f23bf6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VContainer,VImg,VSnackbar})
